import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { TenantContainerModel } from '../../../../../models/aggregates/tenant';
import { ApiResponseModel, BasicApiResponseModel, Pagination, PagingResponseModel } from '../shared';
import { ApiVisa } from './../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantService extends BaseApiTemplateService<TenantContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenants';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenants';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenants';
    this.httpClient = http;
  }

  getTenantDetails(pagination: Pagination, visa: ApiVisa): Observable<ApiResponseModel<TenantContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + 'query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<ApiResponseModel<TenantContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

  getByCriteriaSysAdmin(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<TenantContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/sysadmin-ep/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<TenantContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

  createTenantSysAdmin(dto: TenantContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<TenantContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/sysadmin-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<TenantContainerModel>>(
      this.apiUrl, dto, this.getHttpHeader(visa)
    );
  }

  updateTenantSysAdmin(dto: TenantContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<TenantContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/sysadmin-ep';
    }
    return this.httpClient.put<BasicApiResponseModel<TenantContainerModel>>(
      this.apiUrl, dto, this.getHttpHeader(visa)
    );
  }

  private setUrl(endpoint: string, apiVisa: ApiVisa){
    this.apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + `tenants/${endpoint}`;
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + `tenants/${endpoint}`
  }

  getByGuidAsSysadmin(guid: string, apiVisa: ApiVisa){
    this.setUrl('sysadmin-ep', apiVisa)
    return super.getByGuid(guid, apiVisa);
  }
}